export const NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS = {
	onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
	takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
	isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
	templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues',
} as const;

export const NthUserHomeOnboardingRevampKeys = [
	...Object.values(NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS),
] as const;
